import { Typography } from "@/design-system/Atoms";
import { AppEmptyState } from "@/design-system/Feedbacks";
import { DASHBOARD_TABS } from "@/constants/dashboardTabs";
import { VideosList } from "./VideosList";
import { useVideoService } from "@/rtkQuery/features/hooks/useVideoService";
import VideosTabShimmer from "./VideosTabShimmer";
import { useScrollToTopOnMount } from "@/hooks/useScrollToTopOnMount";

export const MyVideosSection = () => {
  useScrollToTopOnMount();
  const {
          watchedVideos,
          watchedVideosLoading,
      } = useVideoService();
  return (
    <div className="rounded-[20px] bg-[#f6f7f9] p-8" id="v-pills-tabContent">
      <div
        id={DASHBOARD_TABS.MY_VIDEO}
        role="tabpanel"
        aria-labelledby={DASHBOARD_TABS.MY_VIDEO}
        className=" block opacity-100"
      >
        <Typography
          variant="darkBackgroundHeading"
          as="h3"
          className="animate-fade-in-up"
        >
          Videos
        </Typography>
        {watchedVideosLoading ? (
          <VideosTabShimmer />
        ) : !watchedVideosLoading && watchedVideos &&
          watchedVideos?.length === 0 ? (
          <div className="w-fit mx-auto px-4">
            <div className="rounded-[20px] min-h-[40vh] lg:min-h-[35vh] flex items-center justify-center">
              <AppEmptyState message="No videos found." />
            </div>
          </div>
        ) : (
          <div>
            <VideosList data={watchedVideos!} />
          </div>
        )}
      </div>
    </div>
  );
};
export default MyVideosSection;
